import { DataService } from "./../../services/data/data.service";
import {
  ConnectionPositionPair,
  Overlay,
  OverlayPositionBuilder,
  OverlayRef,
} from "@angular/cdk/overlay";
import { ComponentPortal } from "@angular/cdk/portal";
import {
  ComponentRef,
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnInit,
} from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { PopoverComponent } from "./popover.component";

@Directive({
  selector: "[appPopover]",
})
export class PopoverDirective implements OnInit {
  @Input("appPopover") text = "";
  private overlayRef: OverlayRef;
  private unsubscribe = new Subject();

  constructor(
    private overlay: Overlay,
    private overlayPositionBuilder: OverlayPositionBuilder,
    private elementRef: ElementRef,
    public data: DataService
  ) { }
  ngOnInit(): void {
    // this.createOverlay();
    // const scrollStrategy = this.overlay.scrollStrategies.block();
    // // throw new Error("Method not implemented.");
    // const positionStrategy = this.overlayPositionBuilder
    //   // Create position attached to the elementRef
    //   .flexibleConnectedTo(this.elementRef)
    //   // Describe how to connect overlay to the elementRef
    //   // Means, attach overlay's center bottom point to the
    //   // top center point of the elementRef.
    //   .withPositions([
    //     {
    //       originX: "end",
    //       originY: "top",
    //       overlayX: "end",
    //       overlayY: "bottom",
    //     },
    //     {
    //       originX: "end",
    //       originY: "top",
    //       overlayX: "end",
    //       overlayY: "bottom",
    //     },
    //   ]);
    this.overlayRef = this.overlay.create();
  }

  private createOverlay(): void {
    const scrollStrategy = this.overlay.scrollStrategies.block();

    const position = [
      new ConnectionPositionPair(
        { originX: "start", originY: "bottom" },
        { overlayX: "start", overlayY: "bottom" }
      ),
      new ConnectionPositionPair(
        { originX: "start", originY: "bottom" },
        { overlayX: "start", overlayY: "bottom" }
      ),
    ];

    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(this.elementRef)
      .withPositions(position);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy,
      hasBackdrop: true,
      backdropClass: "",
    });

    this.overlayRef
      .backdropClick()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(() => {
        this.detachOverlay();
      });
  }

  @HostListener("mouseenter")
  show() {
    const tooltipPortal = new ComponentPortal(PopoverComponent);

    // Attach tooltip portal to overlay
    const tooltipRef: ComponentRef<PopoverComponent> =
      this.overlayRef.attach(tooltipPortal);
    this.overlayRef.updatePositionStrategy(
      this.overlayPositionBuilder
        .flexibleConnectedTo(this.elementRef)
        .withPositions([
          {
            originX: "end",
            originY: "center",
            overlayX: "start",
            overlayY: "top",
            offsetY: -16,
            offsetX: 0,
          },
        ])
    );
    this.overlayRef.updatePosition();
    // Pass content to tooltip component instance
    tooltipRef.instance.text = this.text;
    if (
      this.data.responsiveType === "tabletL" ||
      this.data.responsiveType === "tabletP"
    ) {
      setTimeout(() => {
        // // console.log("call");
        this.detachOverlay();
      }, 700);
    }
  }

  @HostListener("mouseleave")
  hide() {
    // // console.log("call");
    this.detachOverlay();
  }

  detachOverlay() {
    if (this.overlayRef.hasAttached()) {
      this.overlayRef.detach();
    }
  }

  private getOffsetY() {
    // if (this.elementRef.nativeElement.getBoundingClientRect().bottom > 500)
    //   return -400;
    // if (this.elementRef.nativeElement.getBoundingClientRect().bottom > 400)
    //   return -300;
    // if (this.elementRef.nativeElement.getBoundingClientRect().bottom > 300)
    //   return -200;
    return -10;
  }
}
